export default __webpack_public_path__ + "static/media/js-snippet.a11de256.svg";